import React, { useState } from 'react';

const ExportImport = ({ materias, orientacionSeleccionada, cpoPuntos, onImportData }) => {
  const [importText, setImportText] = useState('');
  const [showImport, setShowImport] = useState(false);

  const exportData = () => {
    const dataToExport = {
      materias,
      orientacionSeleccionada,
      cpoPuntos,
      timestamp: new Date().toISOString(),
      version: '1.0'
    };
    
    const exportString = JSON.stringify(dataToExport, null, 2);
    const blob = new Blob([exportString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `mapa-abogacia-backup-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const copyToClipboard = () => {
    const dataToExport = {
      materias,
      orientacionSeleccionada,
      cpoPuntos,
      timestamp: new Date().toISOString(),
      version: '1.0'
    };
    
    navigator.clipboard.writeText(JSON.stringify(dataToExport, null, 2))
      .then(() => alert('✅ Progreso copiado al portapapeles'))
      .catch(() => alert('❌ Error al copiar'));
  };

  const handleImport = () => {
    try {
      const importedData = JSON.parse(importText);
      
      if (!importedData.materias || !importedData.version) {
        alert('❌ Archivo de backup inválido');
        return;
      }

      const confirmImport = window.confirm(
        '⚠️ ¿Estás seguro? Esto sobrescribirá tu progreso actual.\n\n' +
        `Backup del: ${new Date(importedData.timestamp).toLocaleDateString()}`
      );

      if (confirmImport) {
        onImportData(importedData);
        setImportText('');
        setShowImport(false);
        alert('✅ Progreso importado exitosamente');
      }
    } catch (error) {
      alert('❌ Error: El formato del backup no es válido');
    }
  };

  return (
    <div style={{ 
      margin: '0',
      padding: '10px',
      backgroundColor: 'transparent',
      borderRadius: '8px',
      border: 'none'
    }}>
      <h4 style={{ color: 'var(--accent-color)', marginBottom: '15px' }}>
        💾 Backup del Progreso
      </h4>
      
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px' }}>
        <button
          onClick={exportData}
          style={{
            padding: '10px 15px',
            backgroundColor: 'var(--success-color)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.9em'
          }}
        >
          📥 Descargar Backup
        </button>

        <button
          onClick={copyToClipboard}
          style={{
            padding: '10px 15px',
            backgroundColor: 'var(--accent-color)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.9em'
          }}
        >
          📋 Copiar al Portapapeles
        </button>

        <button
          onClick={() => setShowImport(!showImport)}
          style={{
            padding: '10px 15px',
            backgroundColor: 'var(--warning-color)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '0.9em'
          }}
        >
          📤 Restaurar Backup
        </button>
      </div>

      {showImport && (
        <div style={{ marginTop: '15px' }}>
          <p style={{ fontSize: '0.9em', color: 'var(--text-secondary)', marginBottom: '10px' }}>
            Pegá aquí el contenido de tu backup:
          </p>
          <textarea
            value={importText}
            onChange={(e) => setImportText(e.target.value)}
            placeholder="Pegá el contenido de tu backup aquí..."
            style={{
              width: '100%',
              height: '120px',
              padding: '10px',
              borderRadius: '4px',
              border: '1px solid var(--border-color)',
              backgroundColor: 'var(--bg-primary)',
              color: 'var(--text-primary)',
              fontSize: '0.85em',
              fontFamily: 'monospace'
            }}
          />
          <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
            <button
              onClick={handleImport}
              disabled={!importText.trim()}
              style={{
                padding: '8px 15px',
                backgroundColor: importText.trim() ? 'var(--success-color)' : 'var(--text-muted)',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: importText.trim() ? 'pointer' : 'not-allowed',
                fontSize: '0.9em'
              }}
            >
              ✅ Importar
            </button>
            <button
              onClick={() => {
                setShowImport(false);
                setImportText('');
              }}
              style={{
                padding: '8px 15px',
                backgroundColor: 'var(--text-muted)',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9em'
              }}
            >
              ❌ Cancelar
            </button>
          </div>
        </div>
      )}

      <p style={{ 
        fontSize: '0.8em', 
        color: 'var(--text-secondary)', 
        marginTop: '15px',
        fontStyle: 'italic'
      }}>
        💡 Recomendamos hacer backup regularmente. Guardá el archivo en Drive, Dropbox o enviátelo por email.
      </p>
    </div>
  );
};

export default ExportImport; 